import { Offer } from 'src/common/types/models/Offer'
import { areAddressesEqual } from 'src/common/utils/web3/areAddressesEqual'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'

const useOfferPermissions = (offer: Offer) => {
  const { smartAccountInfo } = useSmartAccount()

  return useMemo(() => {
    const timelocked = dayjs.unix(offer.timelockPeriod).isAfter(dayjs())

    const isOwner = Boolean(
      smartAccountInfo?.address && areAddressesEqual(smartAccountInfo?.address, offer.maker)
    )

    const canAnyAction = Boolean(
      isOwner && !offer.isCompleted && !offer.cancelledAt && !timelocked
    )

    const canEditOffer = canAnyAction
    const canCancelOffer = canAnyAction

    return {
      isOwner,
      canEditOffer,
      canCancelOffer,
    }
  }, [
    smartAccountInfo?.address,
    offer.cancelledAt,
    offer.isCompleted,
    offer.maker,
    offer.timelockPeriod,
  ])
}

export default useOfferPermissions
